import React from 'react';
import CurrentUserInfo from "./CurrentUserInfo";
import CompanySelector from "./CompanySelector";

const MainNavEnd = () => {
    return (<div className="nav-info">
        <CurrentUserInfo />
        <CompanySelector />
    </div>);
}

export default MainNavEnd;